module.exports = __webpack_public_path__ + "img/help.cb225abf.svg";